<template>
  <div class="navbar-bookmarks flex items-center">
    <!-- STARRED PAGES - FIRST 10 -->
    <ul class="vx-navbar__starred-pages">
      <!-- <draggable v-model="starredPages" :group="{name: 'pinList'}" class="flex cursor-move"> -->
        <div class="flex cursor-move">
          <li class="starred-page" v-for="page in starredPages" :key="page.url" v-if="page.url">
            <vx-tooltip :text="page.name" position="bottom" delay=".3s">
              <router-link :target="page.target" :to="page.url" :class="['icon-normal-color',textColor]">
                <icon :svgClasses="['h-6 w-6 stroke-current', textColor]" class="p-2 cursor-pointer" :icon="page.icon || 'CircleIcon'" />
              </router-link>
            </vx-tooltip>
          </li>
        </div>
      <!-- </draggable> -->
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },

  $computed: {
    starredPages: 'starredPages',
    textColor() {
      return {'text-white': this.$s.mainLayoutType === 'vertical' && this.navbarColor != (this.$s.theme === 'dark' ? "#10163a" : "#fff") }
    }
  },
}
</script>
<style lang="scss" scoped>
.icon-normal-color {
  color: inherit;
}
</style>
